import React from "react"
import ContentLoader from "react-content-loader" 

const MyLoader = () => (
  <ContentLoader 
    speed={2}
    width={400}
    height={120}
    viewBox="0 0 400 120"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <rect x="9" y="6" rx="0" ry="0" width="121" height="101" /> 
    <rect x="142" y="11" rx="0" ry="0" width="118" height="13" /> 
    <rect x="142" y="36" rx="0" ry="0" width="250" height="13" /> 
    <rect x="143" y="59" rx="0" ry="0" width="250" height="13" /> 
    <circle cx="156" cy="96" r="11" /> 
    <rect x="175" y="93" rx="0" ry="0" width="103" height="8" />
  </ContentLoader>
)

export default MyLoader